import { getGolfPlayerCategory } from "../utils/appUtils";
import { convertToHandicapDetails } from "../utils/courseUtils";
import { CourseConfig } from "./teeBox";

const getCourseHandicaps = (
  player: any,
  courseDetailsForHandicap?: CourseConfig[]
) => {
  const retObject: any = {};
  if (!courseDetailsForHandicap) {
    return retObject;
  }
  const configs = courseDetailsForHandicap.map(convertToHandicapDetails);
  const playerMsl = getGolfPlayerCategory(player.ageCategory, player.gender);
  configs.forEach((course) => {
    const hcp = player.seasonHandicap ? Number(player.seasonHandicap) : player.playerHandicap
      ? Number(player.playerHandicap)
      : null;
    if (hcp !== null && playerMsl) {
      const courseRating = course.courseRating[playerMsl];
      const slopeRating = course.slopeRating[playerMsl];
      const coursePar = course.coursePar;
      const courseHandicap =
        (hcp * slopeRating) / 113 + (courseRating - coursePar);
      const hc = courseHandicap * 0.75;
      retObject[course.courseName.toLowerCase().replace(/\s+/g, "")] =
        Math.round(hc).toString();
    }
  });
  return retObject;
};

export const formatPlayer = (
  player: any,
  courseDetailsForHandicap?: CourseConfig[]
) => {
  return {
    id: player.id,
    fullName: `${player.title} ${player.firstName} ${player.lastName}`,
    category: getGolfPlayerCategory(player.ageCategory, player.gender),

    playerRole: player.role
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/^./, (str: string) => str.toUpperCase()),
    ...player,
    role: getPlayerRole(player),
    playerHandicap: player.playerHandicap
      ? Number(player.playerHandicap).toFixed(1)
      : null,
    ...getCourseHandicaps(player, courseDetailsForHandicap),
  };
};

export const formatPlayers = (
  players: any[],
  courseDetailsForHandicap?: CourseConfig[]
) => {
  return players.map((player) =>
    formatPlayer(player, courseDetailsForHandicap)
  );
};

export const formatPlayersForDraft = (players: any[]) =>
  players
    .map((player) => ({
      fullName: `${player.title} ${player.firstName} ${player.lastName}`,
      ...player,
    }))
    .sort((a, b) => a.playerHandicap - b.playerHandicap);

export enum UserRoles {
  viewer = "viewer",
  admin = "admin",
  player = "player",
  captain = "captain",
  playingTeamOwner = "playingTeamOwner",
  nonPlayingTeamOwner = "nonPlayingTeamOwner",
  dataEntry = "dataEntry",
}

const getPlayerRole = (player: any) => {
  let role = "";
  role = "";
  if (player.isOwner) {
    role = `${role}${role ? ", " : ""}Team Owner`;
  }
  if (player.isCaptain) {
    role = `${role}${role ? ", " : ""}Captain`;
  }
  if (player.isCoreMember) {
    role = `${role}${role ? ", " : ""}Core Member`;
  }
  if (player.isPlayer) {
    role = `${role}${role ? ", " : ""}Player`;
  }
  return role;
};

export const getPlayerCoursePh = (player: any, courseConfig: CourseConfig) => {
  const playerMsl = getGolfPlayerCategory(player.ageCategory, player.gender);
  const course = convertToHandicapDetails(courseConfig);
  const playerHandicap = player.playerHandicap
    ? Number(player.playerHandicap)
    : null;
  if (playerHandicap !== null && playerMsl) {
    const courseRating = course.courseRating[playerMsl];
    const slopeRating = course.slopeRating[playerMsl];
    const coursePar = course.coursePar;
    const courseHandicap =
      (playerHandicap * slopeRating  ) / 113 + (courseRating - coursePar);
    const hc = courseHandicap * 0.75;
    return Math.round(hc).toString();
  }
  return '';
};
